import * as React from 'react'
import $ from 'jquery'
import { accentUtils, from } from '../services/HelperService';
import GRIDS from './_GridDefinitions';
import { RTLGridCtrl } from '../controls/grids/RTLGridCtrl';
import { queryNoTracking } from '../services/DataService';


const query_Leads_Search = queryNoTracking("Leads_Search");


export const NewLeadGrid = React.memo(props => {

    const searchRun = React.useRef(0);
    const gridCtrl = React.useRef();

    const onRowClick = (e) => {
        if (e.row) {
            if (props.onSelectExisting) {
                props.onSelectExisting(e.row);
            }
        } else {
            if (props.onSelectExisting) {
                props.onSelectExisting(null);
            }
        }

    };

    const onRefresh = React.useCallback(e => {
        if (searchRun.current > 0) {
            props.onSearch(gridCtrl.current.getSearchText());
        }


        if (gridCtrl.current.getSelected().length == 0) {

            const firstRow = from(gridCtrl.current.getData()).firstOrDefault();

            if (accentUtils.isNull(firstRow)) {
                gridCtrl.current.select([])
            } else {
                gridCtrl.current.select([firstRow.ID]);
            }
            props.onSelectExisting(firstRow);
        }

    }, [props, searchRun, gridCtrl]);

    const query = React.useCallback(s => {
        if (accentUtils.isEmpty(s))
            return []
        else {
            searchRun.current++;
            return query_Leads_Search.getAllAsQueryableWithCache({ searchString: s });
        }
    }, [searchRun]);

    return <RTLGridCtrl
        methods={gridCtrl}
        query={query}
        height="screen"
        onRowClick={onRowClick}
        strings="leadSearchGrid"
        columns={GRIDS.LeadSearchGrid.Default}
        showToolbar={true}
        showSectionHeader={false}
        allowSearch
        onRefresh={onRefresh}
        gridID="71BE4A3E-A728-4F86-81B9-656254AAE964"
        clearSelection
        clearFilters

    />




});
